module.exports = __webpack_public_path__ + "static/media/google-podcasts.3d3210f5.svg";